/**
 * Legacy SystemApiService module — preserved as an empty AngularJS module so
 * existing dependencies (`acme.common.service.systemApi`) keep resolving.
 *
 * The actual `SystemApiService` factory is now registered in
 * apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts (indirectly,
 * through the ApiService facade). The Angular 18 implementation lives at
 * apps/b2b-frontend/app/core/api/system/system-api.service.ts.
 *
 * Do NOT register `.service('SystemApiService', ...)` here — `apiService.system`
 * is now an Angular 18 `inject(SystemApiService)`, not a `$injector.get(...)`
 * bridge, so the legacy registration would be dead code.
 */
angular.module('acme.common.service.systemApi', [
  'acme.common.factory.apiVersion',
  'acme.common.factory.QueryStringBuilder',
]);
